export default "__VITE_ASSET__DEKSp6c8__"